var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('memoryshare-stream',{attrs:{"slug":_vm.$route.params.slug,"options":"{\"fluid\": false, \"height\": 300, \"width\": 300, \"playerOnly\": true}"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }